import { render, staticRenderFns } from "./Machine.view.vue?vue&type=template&id=dfef476a&"
import script from "./Machine.view.vue?vue&type=script&lang=js&"
export * from "./Machine.view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports